// TODO get rid of the 'path-to-regexp'
import { match } from 'path-to-regexp';
import { NavigationItem, NavigationPageItem, NavigationSubheaderItem } from './navigation.interface';

export const getItemKind = (item: NavigationItem) => item.kind ?? 'page';

export const isPageItem = (item: NavigationItem): item is NavigationPageItem =>
  getItemKind(item) === 'page';

export const getItemTitle = (item: NavigationPageItem | NavigationSubheaderItem) => {
  return isPageItem(item) ? (item.title ?? item.segment ?? '') : item.title;
};

export function getPageItemFullPath(basePath: string, navigationItem: NavigationPageItem) {
  return `${basePath}${basePath && !navigationItem.segment ? '' : '/'}${navigationItem.segment ?? ''}`;
}

export function isPageItemSelected(
  navigationItem: NavigationPageItem,
  basePath: string,
  pathname: string,
) {
  return navigationItem.pattern
    ? Boolean(match(buildMatchingPath(basePath, navigationItem.pattern))(pathname))
    : getPageItemFullPath(basePath, navigationItem) === pathname;
}

const buildMatchingPath = (basePath: string, pattern: string | string[]) => {
  if (Array.isArray(pattern)) {
    return pattern.map((patternItem) => `${basePath}/${patternItem}`);
  }
  return `${basePath}/${pattern}`;
};

export function hasSelectedNavigationChildren(
  navigationItem: NavigationItem,
  basePath: string,
  pathname: string,
): boolean {
  if (isPageItem(navigationItem) && navigationItem.children) {
    const navigationItemFullPath = getPageItemFullPath(basePath, navigationItem);

    return navigationItem.children.some((nestedNavigationItem) => {
      if (!isPageItem(nestedNavigationItem)) {
        return false;
      }

      if (nestedNavigationItem.children) {
        return hasSelectedNavigationChildren(
          nestedNavigationItem,
          navigationItemFullPath,
          pathname,
        );
      }

      return isPageItemSelected(nestedNavigationItem, navigationItemFullPath, pathname);
    });
  }

  return false;
}
